<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up applicant_chk com_pop" style="max-width: 1600px">
        <div class="pop_tit _flex">
            <p>{{ state.boardDetail.title }}</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>
        <div class="date_wrap">
            <template v-if="state.boardDetail.state == 2">
                <span class="state_tag">진행중</span>
            </template>
            <template v-else-if="state.boardDetail.state == 1">
                <span class="state_tag waiting">대기중</span>
            </template>
            <template v-else>
                <span class="state_tag finish">마감</span>
            </template>

            <div class="end_point">
                <span>
                    <img src="img/time_icon.png" alt="" />
                    신청종료일
                </span>
                <span>{{ CommonUtils.dateFormatYY(new Date(state.boardDetail.applyDate), ".") }}</span>
            </div>
            <div class="activity_duration" v-if="state.boardDetail.activeStartDate && state.boardDetail.activeEndDate">
                <span>
                    <img src="img/cal_icon.png" alt="" />
                    활동기간
                </span>
                <span>{{ CommonUtils.dateFormatYY(new Date(state.boardDetail.activeStartDate), ".") }}</span>
                <em>-</em>
                <span>{{ CommonUtils.dateFormatYY(new Date(state.boardDetail.activeEndDate), ".") }}</span>
            </div>
        </div>
        <div class="list_container _flex" v-if="state.eventIdx !== props.idx">
            <div class="left">
                <div class="num_wrap">
                    <span>신청인원</span>
                    <div class="btn_area">
                        <span>{{ CommonUtils.numberFormat(state.totalLength) }} 명</span>
                        <button type="button" class="excel_btn icon_wrap"><img src="img/excel_icon.png" alt="" @click="downloadFile(0)" /></button>
                    </div>
                </div>
                <div class="common_table custom_scroll">
                    <table style="table-layout: auto">
                        <colgroup>
                            <col style="min-width: 70px" />
                            <col style="min-width: 130px; width: auto" v-for="form in state.formList" />
                            <col style="min-width: 100px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>번호</th>
                                <th style="white-space: nowrap; padding: 5px 10px" v-for="form in state.formList">{{ form.title }}</th>
                                <th>신청일</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="state.totalLength > 0">
                                <tr v-for="(item, idx) in state.applyList" :key="item.idx">
                                    <td>{{ (state.page - 1) * state.size + (idx + 1) }}</td>
                                    <td style="white-space: pre-line; padding: 5px" v-for="form in item.formList" v-html="answerFormat(form)"></td>
                                    <td>{{ CommonUtils.dateFormatYY(new Date(item.createDate), ".") }}</td>
                                </tr>
                            </template>
                            <tr v-else>
                                <td :colspan="2 + (state.formList.length > 0 ? state.formList.length : 0)">
                                    <div class="tb_subject" style="text-align: center; width: 100%">신청 인원이 없습니다.</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <PageBtn
                    v-if="state.totalLength > 0"
                    :currentPage="state.page"
                    :totalLength="state.totalLength"
                    :perPage="state.size"
                    :data="state.data"
                    @onPaging="handlePageChange"
                ></PageBtn>
            </div>
        </div>
        <!-- 켐페인 이벤트용 -->
        <div class="list_container _flex" v-else>
            <div class="left">
                <div class="num_wrap">
                    <span>신청인원</span>
                    <div class="btn_area">
                        <span>{{ CommonUtils.numberFormat(state.totalLength) }} 명</span>
                        <button type="button" class="excel_btn icon_wrap"><img src="img/excel_icon.png" alt="" @click="downloadFile(0)" /></button>
                    </div>
                </div>
                <div class="common_table custom_scroll">
                    <table>
                        <colgroup>
                            <col style="width: 10px" />
                            <col style="width: 20px" />
                            <col style="width: 40px" />
                            <col style="width: 30px" />
                            <col style="width: 15px" />
                            <col style="width: 40px" />
                            <col style="width: 40px" />
                            <col style="width: 40px" />
                            <col style="width: 20px" />
                            <col style="width: 15px" v-if="state.boardDetail.idx === state.eventIdx" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>번호</th>
                                <th>이름</th>
                                <th>이메일</th>
                                <th>전화번호</th>
                                <th>연령대</th>
                                <th>당신의 관심이 변화를 만듭니다.</th>
                                <th>‘그들’이 아닌 ‘우리’의 문제입니다.</th>
                                <th>존중과 인권을 이야기합니다.</th>
                                <th>신청일</th>
                                <th v-if="state.boardDetail.idx === state.eventIdx">신청서</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="state.totalLength > 0">
                                <tr v-for="(item, idx) in state.applyList" :key="item.idx">
                                    <td>{{ (state.page - 1) * state.size + (idx + 1) }}</td>
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.email }}</td>
                                    <td>
                                        <span class="_ph">{{ CommonUtils.convertPhoneNumReal(item.phoneNum) }}</span>
                                    </td>
                                    <td>
                                        <span class="_ph" v-if="item.age === 1">10대</span>
                                        <span class="_ph" v-else-if="item.age === 2">20대</span>
                                        <span class="_ph" v-else-if="item.age === 3">30대</span>
                                        <span class="_ph" v-else-if="item.age === 4">40대</span>
                                        <span class="_ph" v-else-if="item.age === 5">50대</span>
                                        <span class="_ph" v-else-if="item.age === 6">60대</span>
                                        <span class="_ph" v-else-if="item.age === 7">70대 이상</span>
                                    </td>

                                    <td class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                        <label :for="'chk_step1_0'" @click.stop>
                                            <input type="checkbox" :id="'chk_step1_0'" v-model="item.step1" :value="0" disabled />
                                        </label>
                                        <label :for="'chk_step1_1'" @click.stop>
                                            <input type="checkbox" :id="'chk_step1_1'" v-model="item.step1" :value="1" disabled />
                                        </label>
                                        <label :for="'chk_step1_2'" @click.stop>
                                            <input type="checkbox" :id="'chk_step1_2'" v-model="item.step1" :value="2" disabled />
                                        </label>
                                    </td>
                                    <td class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                        <label :for="'chk_step2_0'" @click.stop>
                                            <input type="checkbox" :id="'chk_step2_0'" v-model="item.step2" :value="0" disabled />
                                        </label>
                                        <label :for="'chk_step2_1'" @click.stop>
                                            <input type="checkbox" :id="'chk_step2_1'" v-model="item.step2" :value="1" disabled />
                                        </label>
                                        <label :for="'chk_step2_2'" @click.stop>
                                            <input type="checkbox" :id="'chk_step2_2'" v-model="item.step2" :value="2" disabled />
                                        </label>
                                    </td>
                                    <td class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                        <label :for="'chk_step3_0'" @click.stop>
                                            <input type="checkbox" :id="'chk_step3_0'" v-model="item.step3" :value="0" disabled />
                                        </label>
                                        <label :for="'chk_step3_1'" @click.stop>
                                            <input type="checkbox" :id="'chk_step3_1'" v-model="item.step3" :value="1" disabled />
                                        </label>
                                        <label :for="'chk_step3_2'" @click.stop>
                                            <input type="checkbox" :id="'chk_step3_2'" v-model="item.step3" :value="2" disabled />
                                        </label>
                                    </td>
                                    <td>{{ CommonUtils.dateFormatYY(new Date(item.createDate), ".") }}</td>
                                    <td v-if="state.boardDetail.idx === state.eventIdx">
                                        <button type="button" class="table_btn _blue" @click="showAnswer(item)">보기</button>
                                    </td>
                                </tr>
                            </template>
                            <tr v-else>
                                <td colspan="6"><div class="tb_subject" style="text-align: center; width: 100%">신청 인원이 없습니다.</div></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <PageBtn
                    v-if="state.totalLength > 0"
                    :currentPage="state.page"
                    :totalLength="state.totalLength"
                    :perPage="state.size"
                    :data="state.data"
                    @onPaging="handlePageChange"
                ></PageBtn>
            </div>
        </div>
        <div>
            <div class="memo_wrap" v-if="state.eventIdx !== props.idx">
                <div>
                    <label for="cntWin">당첨인원</label>
                    <input type="number" id="cntWin" v-model="state.boardDetail.cntWin" />
                </div>
                <div>
                    <label for="memo">메모</label>
                    <textarea id="memo" class="custom_scroll" placeholder="내용을 입력해주세요." v-model="state.boardDetail.memo"></textarea>
                </div>
            </div>
            <div class="step_content" v-else>
                <div>
                    <h1>당신의 관심이 변화를 만듭니다.</h1>
                    <p class="checkbox_wrap2">
                        <label @click.stop>
                            <input type="checkbox" disabled />
                        </label>
                        외면도, 무관심도, 침묵도 성매매 카르텔입니다.
                    </p>
                    <p class="checkbox_wrap2">
                        <label @click.stop>
                            <input type="checkbox" disabled />
                        </label>
                        ANTI 성매매에 끊임없이 관심을 가집시다.
                    </p>
                    <p class="checkbox_wrap2">
                        <label @click.stop>
                            <input type="checkbox" disabled />
                        </label>
                        성매매는 사회의 병적인 존재다. 이제는 변화해야 한다. 제발...
                    </p>
                </div>
                <div>
                    <h1>‘그들’이 아닌 ‘우리’의 문제입니다.</h1>
                    <p class="checkbox_wrap2">
                        <label @click.stop>
                            <input type="checkbox" disabled />
                        </label>
                        성매매 문제는 남의 일이 아닙니다. 우리가 반드시 해결해야 하므로 함께 해 주십시오
                    </p>
                    <p class="checkbox_wrap2">
                        <label @click.stop>
                            <input type="checkbox" disabled />
                        </label>
                        '그들'(성매매 여성)만의 문제가 아닌 '우리'(여성 그리고 모두)의 문제입니다.
                    </p>
                    <p class="checkbox_wrap2">
                        <label @click.stop>
                            <input type="checkbox" disabled />
                        </label>
                        성매매는 '불법', 성구매자는 '전과자'입니다.
                    </p>
                </div>
                <div>
                    <h1>존중과 인권을 이야기합니다.</h1>
                    <p class="checkbox_wrap2">
                        <label @click.stop>
                            <input type="checkbox" disabled />
                        </label>
                        성매매는 인권의 문제! 성매매라고 쓰고 성착취(성폭력)라고 읽는다.
                    </p>
                    <p class="checkbox_wrap2">
                        <label @click.stop>
                            <input type="checkbox" disabled />
                        </label>
                        2차 피해만큼은 하지 마십시오. 당신도 똑같은 가해자입니다.
                    </p>
                    <p class="checkbox_wrap2">
                        <label @click.stop>
                            <input type="checkbox" disabled />
                        </label>
                        성매매 없는 사회, 인간의 존중과 가치를 보여주세요.
                    </p>
                </div>
            </div>
        </div>
        <div class="_flex _center btn_wrap" v-if="state.eventIdx !== props.idx">
            <button class="submit_btn _130 _main_blue" @click="save()">저장</button>
        </div>
    </div>
    <SpotTheDiff
        v-if="state.isShowAnswer"
        :answerInfo="state.answerInfo"
        @close="state.isShowAnswer = false"
        @callback="
            state.isShowAnswer = false;
            getApplyList();
        "
    ></SpotTheDiff>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="state.isShowModal = false"
    ></ModalDefault>
</template>
<script lang="ts">
    import {
        onMounted,
        reactive,
        watch,
        onUnmounted,
        CommonUtils,
        apiService,
        types,
        getMessageByCode,
        PageBtn,
        AnswerModal,
        ModalDefault,
    } from "@/BaseComponent";
    import SpotTheDiff from "@/views/components/modal/event/spotTheDiff.vue";

    export default {
        props: {
            idx: {
                type: Number,
                default: 0,
            },
        },
        emits: ["close", "saveForMemoCntWin", "exportExcelForEventApply"],
        components: {
            PageBtn,
            AnswerModal,
            ModalDefault,
            SpotTheDiff,
        },
        setup(props: any, { emit }: any) {
            const state = reactive({
                idx: 0 as number,
                eventIdx: 139 as number | null,
                data: {} as any,
                dataForPick: {} as any,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                boardDetail: {} as types.ResBoardVOForApi,

                formList: [] as Array<types.BoardApplyFormVOForApi>,
                applyList: [] as Array<types.ResEventApplyVOForApi>,
                page: 1 as number,
                size: 10 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                checkAll: false as boolean,
                checkedList: [] as Array<number>,
                checkAllPick: false as boolean,
                checkedListPick: [] as Array<number>,

                isShowAnswer: false as boolean,
                answerInfo: {} as any,

                isPick: false as boolean,
            });

            onMounted(() => {
                init();
            });

            onUnmounted(() => {});

            watch(
                () => [state.checkedList, state.applyList],
                () => {
                    state.checkAll = state.applyList.length !== 0 && state.checkedList.length === state.applyList.length;
                },
            );

            watch(
                () => props.idx,
                () => init(),
            );

            const init = () => {
                boardDetail();
                if (props.idx > 0) {
                    state.idx = props.idx;
                    if (state.eventIdx === props.idx) eventApplayList();
                    else {
                        getFormList();
                        getApplyList();
                    }
                }
            };

            const closeModal = () => emit("close");

            const handlePageChange = (page: number) => {
                state.page = page;
                if (state.eventIdx === props.idx) eventApplayList();
                else getApplyList();
            };

            const save = () => {
                emit("saveForMemoCntWin", state.boardDetail);
            };

            const toggleAll = () => {
                if (state.checkAll) {
                    state.checkedList = state.applyList.map((item: any) => item.idx);
                } else {
                    state.checkedList = [];
                }
            };

            const downloadFile = (type: number) => {
                emit("exportExcelForEventApply", type, props.idx);
            };

            const boardDetail = async () => {
                const res = await apiService.board.detail(2, props.idx);

                if (res.returnCode === 0) {
                    state.boardDetail = res.data;
                }
            };

            // 틀린그림찾기, '침묵 대신 말' 등 특정 이벤트용 API
            const eventApplayList = async () => {
                if (!state.eventIdx) return;
                const param: types.ReqCommonPaging = {
                    searchText: "",
                    searchType: "",
                    page: state.page,
                    size: state.size,
                };
                const res = await apiService.campainEvent.applyList(state.eventIdx, param);
                if (res.returnCode === 0) {
                    state.applyList = res.list.data.map((item: any) => {
                        return {
                            ...item,
                            step1: item.step1.split(",").map((v: string) => Number(v)),
                            step2: item.step2.split(",").map((v: string) => Number(v)),
                            step3: item.step3.split(",").map((v: string) => Number(v)),
                        };
                    });
                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else {
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };

            const getApplyList = async () => {
                const param: types.ReqBoardApplyList = {
                    searchText: "",
                    searchType: "",
                    page: state.page,
                    size: state.size,
                    boIdx: props.idx,
                };
                const res = await apiService.board.listForApplyForEvent(props.idx, param);
                if (res.returnCode === 0) {
                    state.applyList = res.list.data;
                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else {
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };

            const getFormList = async () => {
                state.formList = [];

                const res = await apiService.board.listForForm(state.idx);
                if (res.returnCode === 0) {
                    state.formList = res.data;
                } else {
                    console.error(res.description);
                    state.formList = [];
                }
            };

            const showAnswer = (item: any) => {
                state.answerInfo = item;
                state.answerInfo.name = item.name;
                state.isShowAnswer = true;
            };

            const answerFormat = (question: types.ResFormListVOForApi) => {
                let answer = "";
                if (question.type === 3) {
                    answer = question.answer;
                } else if (question.caseList && question.caseList.length > 0) {
                    answer += question.caseList
                        .map((caseItem) => {
                            if (caseItem.title === "기타") return `기타(${question.answer})`;
                            else return caseItem.title;
                        })
                        .join("\n");
                }

                return answer;
            };

            return {
                state,
                closeModal,
                props,
                CommonUtils,
                save,
                handlePageChange,
                downloadFile,
                getApplyList,
                showAnswer,
                toggleAll,
                confirm,
                answerFormat,
            };
        },
    };
</script>

<style scoped>
    .applicant_chk .common_table {
        overflow: auto;
        max-height: calc(100vh - 650px);
        width: 100%;
    }

    .btn_area button {
        border-radius: 50px;
        background-color: #fff;
        color: #000;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: 400;
        transition: 0.2s;
        padding-bottom: 2px;
        vertical-align: bottom;
        margin-left: 10px;
    }

    .btn_area button.icon_wrap img {
        height: 22px;
    }

    .btn_area button:where(.next_btn, .last_btn) img {
        transform: rotate(180deg);
    }

    .btn_area button:not(.active):hover {
        background-color: #d9d9d9;
        transition: 0.2s;
    }

    .btn_area button.active {
        background-color: #000;
        color: #fff;
        transition: 0.2s;
    }

    .memo_wrap {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    .memo_wrap > div {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }
    .memo_wrap > div label {
        min-width: 60px;
    }
    .memo_wrap > div input[type="number"] {
        padding: 2px 10px;
        font-size: 15px;
        font-family: sans-serif;
        border: 1px solid #d6d6d6;
        border-radius: 5px;
    }
    .applicant_chk textarea {
        margin-top: 0;
    }
    .list_container .left {
        width: 100%;
    }
</style>
